import { useContext, useState } from 'react';

import { IdContext } from '../../context';

export function useClient() {
  const { clientId, redirectURL, tenancy, product, clientState, sessionMfa } =
    useContext(IdContext);

  const [mfaSessionToken, setMfaSessionToken] = useState<string>(
    sessionMfa ? sessionMfa.token : undefined
  );

  const isBrowser = typeof window !== 'undefined';

  const updateMfaToken = (token: string) => {
    if (isBrowser) {
      localStorage.setItem(sessionMfa.storageKey, token);
      setMfaSessionToken(token);
    }
  };

  const getMfaToken = () => {
    return (
      (isBrowser && localStorage.getItem(sessionMfa.storageKey)) || undefined
    );
  };

  return {
    clientId,
    redirectURL,
    tenancy,
    product,
    clientState,
    mfaToken: mfaSessionToken,
    getMfaToken,
    updateMfaToken,
  } as const;
}
